import styled from 'styled-components'

export const NavBarLinks = styled.div`
    display: flex;
    flex-grow: 1;
    justify-content: flex-start;
    height: 100%;
`
